export default __webpack_public_path__ + "static/media/logo.b02a2073.png";